import type { StringTable } from '#contract'

/** The in-game OS's strings: the shell, its apps and the shop kit. Spread into `en`. */
export const enOs = {
  'os.phone': 'Phone',
  'os.computer': 'Computer',
  'os.home': 'Home',
  'os.apps': 'Apps',
  'os.dock': 'Dock',
  'os.desktop': 'Desktop',
  'os.system': 'System',
  'os.standUp': 'Stand up',
  'os.menuBar.clock': '{weekday} {time}',
  'os.menu.file': 'File',
  'os.menu.edit': 'Edit',
  'os.menu.view': 'View',
  'os.menu.newWindow': 'New Window',
  'os.menu.closeWindow': 'Close Window',
  'os.menu.undo': 'Undo',
  'os.menu.copy': 'Copy',
  'os.menu.paste': 'Paste',
  'os.menu.enterFullScreen': 'Enter Full Screen',
  'os.menu.showSidebar': 'Show Sidebar',
  'os.badge': '{n} new',
  'os.window.close': 'Close',
  'os.window.minimise': 'Minimise',
  'os.window.zoom': 'Zoom',
  'os.app.wassup.name': 'Wassup',
  'os.app.wassup.empty': 'No chats yet. Nobody has anything to tell you.',
  'os.app.wassup.chats': 'Chats',
  'os.app.wassup.unread': '{n} unread',
  'os.app.wassup.back': 'Chats',
  'os.app.wassup.official': 'Official account',
  'os.app.wassup.pick': 'Pick a chat to read it.',
  'os.app.lockedin.name': 'LockedIn',
  'os.app.lockedin.empty': 'Your network is warming up.',
  'os.app.lockedin.search': 'Search',
  'os.app.grubfood.name': 'Grub Food',
  'os.app.grubfood.empty': 'Grub Food delivers to your home.',
  'os.app.grubfood.headline': 'Hungry? We deliver.',
  'os.app.24seven.name': '24Seven',
  'os.app.24seven.empty': '24Seven delivers to your home, day and night.',
  'os.app.files.name': 'Files',
  'os.app.files.empty': 'Nothing here yet.',
  'os.app.files.recents': 'Recents',
  'os.app.phone.name': 'Phone',
  'os.app.phone.empty': 'No recent calls.',
  'os.app.phone.recents': 'Recents',
  'os.app.wellfare.name': 'Wellfare',
  'os.app.wellfare.empty': 'Please try again during office hours, which are also closed.',
  'os.app.wellfare.closed': 'The e-service is unavailable',
  'os.app.wellfare.motto': 'We’re here for you. Eventually.',
  'os.app.wellfare.benefit': 'Unemployment Wellbeing Allowance',
  'os.app.wellfare.perWeek': '{money} / week',
  'os.app.wellfare.terms':
    'Paid on Mondays at 12:00 for a complete application. Incomplete applications receive our thoughts and prayers.',
  'os.app.wellfare.week': 'Application, week {week}',
  'os.app.wellfare.progress': '{parts}/{required} completed',
  'os.app.wellfare.deadline': 'Deadline',
  'os.app.wellfare.payday': 'Payday',
  'os.app.wellfare.leftDays': '{d} d {h} h left',
  'os.app.wellfare.leftHours': '{h} h left',
  'os.app.wellfare.leftSoon': 'under an hour left',
  'os.app.wellfare.part.existence.title': 'Part 1: Proof of existence',
  'os.app.wellfare.part.existence.detail':
    'Confirm that you are alive, unemployed and mildly disappointed.',
  'os.app.wellfare.part.income.title': 'Part 2: Income and other fantasies',
  'os.app.wellfare.part.income.detail':
    'Declare every euro you earned. Bottle deposits count. Dreams do not.',
  'os.app.wellfare.part.diary.title': 'Part 3: Job-seeking diary',
  'os.app.wellfare.part.diary.detail':
    'Describe your efforts to find work this week. Creative writing is encouraged.',
  'os.app.wellfare.filed': 'Filed',
  'os.app.wellfare.hours': '≈ {h} h',
  'os.app.wellfare.apply': 'Fill in part {n}',
  'os.app.wellfare.filling': 'Filling in…',
  'os.app.wellfare.cost':
    'Takes {h} hours of your life. Your fun and energy will not survive it intact.',
  'os.app.wellfare.complete':
    'Application complete. Your {money} arrives on Monday at 12:00. Probably.',
  'os.app.wellfare.lastPaid': 'Week {week}: {money} paid. The system works!',
  'os.app.wellfare.lastRefused': 'Week {week}: refused. The application was incomplete.',
  'os.app.wellfare.footer':
    'Wellfare processes your personal data in accordance with whatever we feel like. Current phone queue: 4 h 12 min.',
  'shop.deliverTo': 'Deliver to',
  'shop.home': 'Home',
  'shop.homeIn': 'Home · about {time}',
  'shop.balance': 'Balance {money}',
  'shop.back': 'Back',
  'shop.orders': 'Your orders',
  'shop.restaurants': 'Restaurants',
  'shop.aisles': 'Aisles',
  'shop.everything': 'Everything',
  'shop.menu': 'Menu',
  'shop.deliveryLine': '{time} · {fee} delivery',
  'shop.feeShort': '{fee} delivery',
  'shop.priceIn': '{price} · {section}',
  'shop.add': 'Add {name}',
  'shop.less': 'One less {name}',
  'shop.more': 'One more {name}',
  'shop.item': '1 item',
  'shop.items': '{n} items',
  'shop.basket': 'Basket',
  'shop.viewBasket': 'View basket',
  'shop.basketBar': '{items} · {money} · View basket',
  'shop.empty': 'Your basket is empty.',
  'shop.keepShopping': 'Keep shopping',
  'shop.subtotal': 'Subtotal',
  'shop.fee': 'Delivery fee',
  'shop.total': 'Total',
  'shop.balanceAfter': 'Balance after',
  'shop.yourBalance': 'Your balance',
  'shop.emptyBasket': 'Empty basket',
  'shop.placeOrder': 'Place order · {total}',
  'shop.placing': 'Placing order…',
  'shop.notEnough': 'Not enough money: you need {money} more.',
  'shop.unavailable': 'No delivery to this address',
  'shop.refused.funds': "You don't have enough money for this order.",
  'shop.refused.empty': 'Your basket is empty.',
  'shop.refused.unknown': "Something in your basket isn't sold any more.",
  'shop.order': 'Order #{id}',
  'shop.orderLine': '{items} · {money}',
  'shop.noOrders': 'No orders on their way.',
  'shop.arriving': 'Arriving in',
  'shop.arrived': 'Delivered',
  'shop.eta': 'about {eta}',
  'shop.arrivingSoon': 'Any minute now',
  'shop.step.placed': 'Placed',
  'shop.step.onTheWay': 'On the way',
  'shop.step.atDoor': 'At the door',
  'shop.knock': "We'll knock when it's at your front door.",
  'shop.pickUp': 'Pick it up at your front door.',
  'shop.lineCount': '{n}× {name}',
  'shop.unknownItem': 'Something',
  'shop.paid': 'Paid',
  'shop.collected': 'This order has been picked up.',
} as const satisfies StringTable
